export default {
  title: {
    it: 'Family Time!',
    de: 'Family Time!',
    fr: 'Family Time!',
    en: 'Family Time!'
  },

  description: {
    it: 'Quante persone ci sono nella tua famiglia?',
    de: 'Wie viele Personen sind in deiner Familie?',
    fr: 'Combien de personnes y a-t-il dans ta famille ?',
    en: 'How many people are in your family?'
  },

  adultsLabel: {
    it: 'Adulti',
    de: 'Erwachsene',
    fr: 'Adultes',
    en: 'Adults'
  },

  childrenLabel: {
    it: 'Bambini',
    de: 'Kinder',
    fr: 'Enfants',
    en: 'Children'
  },

  skipAges: {
    it: "Facoltativo: aggiungi l’età dei tuoi figli per ricevere offerte per famiglie più pertinenti.",
    de: 'Optional: Füge das Alter deiner Kinder hinzu, um relevantere Familienangebote zu erhalten.',
    fr: "Optionnel : ajoute l’âge de tes enfants pour recevoir des offres familiales plus pertinentes.",
    en: "You can skip children's ages if you prefer"
  },

  birthDateLabel: {
    it: 'Data di nascita',
    de: 'Geburtsdatum',
    fr: 'Date de naissance',
    en: 'Date of birth'
  },

  birthMonthLabel: {
    it: 'Mese di nascita',
    de: 'Geburtsmonat',
    fr: 'Mois de naissance',
    en: 'Birth month'
  },

  birthYearLabel: {
    it: 'Anno di nascita',
    de: 'Geburtsjahr',
    fr: 'Annee de naissance',
    en: 'Birth year'
  },

  birthDatePlaceholder: {
    it: 'Seleziona data',
    de: 'Datum wahlen',
    fr: 'Choisir date',
    en: 'Select date'
  },

  button: {
    it: 'Avanti',
    de: 'Weiter',
    fr: 'Continuer',
    en: 'Next'
  }
};
